import { Flex, Typography } from 'antd'
import type { ReactNode } from 'react'

const { Text } = Typography

type Props = {
  title: ReactNode
  subtitle: ReactNode
}

export const AuditPanelHeader = ({ title, subtitle }: Props) => (
  <Flex vertical style={{ lineHeight: 1.3 }}>
    <Text strong style={{ fontSize: 14 }}>
      {title}
    </Text>
    <Text type="secondary" style={{ fontSize: 12 }}>
      {subtitle}
    </Text>
  </Flex>
)
